import { makeStyles } from '@material-ui/core/styles'

const useRichTextBodyTableStyles = makeStyles((theme) => ({
  tableScroll: {
    marginBottom: theme.spacing(4),
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    width: '100%',
    maxWidth: '100%',
  },
  table: {
    width: '100%',
    minWidth: 280,
    borderCollapse: 'collapse',
    borderTop: `1px solid ${theme.palette.grey.light}`,
    fontSize: 14,
    lineHeight: 1.45,
    [theme.breakpoints.up('sm')]: {
      fontSize: 15,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
    '& tbody tr:first-child td': {
      paddingTop: theme.spacing(2),
    },
    '& tbody tr:first-child th': {
      paddingTop: theme.spacing(2),
    },
    '& td, & th': {
      borderBottom: 'none',
      verticalAlign: 'text-top',
      padding: theme.spacing(1),
      '& p': {
        marginBottom: 1,
        marginTop: 0,
      },
    },
    '& td:first-child, & th:first-child': {
      fontWeight: 'bolder',
      color: theme.palette.primary.main,
      paddingLeft: 0,
    },
    '& td:last-child, & th:last-child': {
      paddingRight: 0,
    },
    '& th': {
      backgroundColor: theme.palette.blue.light25,
      fontWeight: 600,
      textAlign: 'left',
    },
  },
}))

export default useRichTextBodyTableStyles
